var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 11.1429 6 15.4286 6 15.4286C6 15.4286 12 11.1429 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0ZM6 13.2257C4.28571 11.7 1.71429 8.83714 1.71429 6C1.71429 4.86336 2.16582 3.77327 2.96954 2.96954C3.77327 2.16582 4.86336 1.71429 6 1.71429C7.13664 1.71429 8.22673 2.16582 9.03046 2.96954C9.83418 3.77327 10.2857 4.86336 10.2857 6C10.2857 8.84571 7.71429 11.7086 6 13.2257Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99993 7.71434C6.9467 7.71434 7.71422 6.94683 7.71422 6.00005C7.71422 5.05328 6.9467 4.28577 5.99993 4.28577C5.05316 4.28577 4.28564 5.05328 4.28564 6.00005C4.28564 6.94683 5.05316 7.71434 5.99993 7.71434Z",
    fill: "#E40000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSelect);
export default __webpack_public_path__ + "static/media/location_select.4e99d8751413cda70e808eb79f73f92b.svg";
export { ForwardRef as ReactComponent };